module.exports = __webpack_public_path__ + "img/logo-lumbredocs-black.6b5a700f.png";